import { useMutationState } from "@tanstack/react-query";

import { getsendChatMessageMutationKey } from "./useSendChatMessage";

/**
 * Hook that observes ALL pending sends by checking React Query's mutation cache for a given chatId.
 *
 * @example
 * const isSending = useIsSendingChatMessage(chatId);
 * const isInputDisabled = chatTask.status !== "assigned" || isSending;
 */
export function useIsSendingChatMessage(chatId: string): boolean {
    const pendingMutations = useMutationState({
        filters: {
            mutationKey: getsendChatMessageMutationKey(chatId),
            status: "pending",
        },
        select: (mutation) => mutation.state.status,
    });

    return pendingMutations.length > 0;
}
